import { createFileRoute } from "@tanstack/react-router";
import { FunilCursoPage } from "@/components/funis/FunilCursoPage";
import { FUNIS } from "@/lib/funis/config";

const cfg = FUNIS["funil-us"];

export const Route = createFileRoute("/funil-us")({
  head: () => ({
    meta: [
      { title: "Curso Gratuito: Ultrassom Terapêutico" },
      { name: "description", content: "Curso online e gratuito de Ultrassom Terapêutico com evidências mais recentes: dosimetria, aplicações em fraturas, osteoartrite e tendinopatias. Certificado incluso." },
      { property: "og:title", content: "Curso Gratuito: Ultrassom Terapêutico" },
      { property: "og:description", content: "O que as evidências mais recentes mostram sobre o Ultrassom Terapêutico na área musculoesquelética. Curso 100% gratuito, com certificado." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://fisioemortopedia.com.br/funil-us" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Curso Gratuito: Ultrassom Terapêutico" },
      { name: "twitter:description", content: "Curso 100% gratuito, online, com certificado de 5h." },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/funil-us" }],
  }),
  component: () => <FunilCursoPage cfg={cfg} />,
});
